// THE price, for every screen (LAUNCH-CHECKLIST H6 — Rob's decision 08/10/2026, built 13/10/2026).
//
//   £1 per person per month, every feature included.
//   Pay for a year up front and get 10% off: £10.80 per person per year.
//
// ⚠️ The backend's copy is backend/services/pricing.py — what is actually CHARGED comes from
// there. backend/tests/test_pricing.py reads this file and fails if the two disagree, so a
// screen can't advertise one price while the bank collects another.
//
// ⚠️ Until 13/10/2026 the price was typed out in about fourteen places, and the annual one
// still said £10 ("2 months free") everywhere after Rob had decided on 10% off.
// Money is in pence so 12 × 90p is exactly 1080, not 10.799999999999999.

export const MONTHLY_PENCE = 100;
export const ANNUAL_DISCOUNT_PERCENT = 10;
export const ANNUAL_PENCE = (12 * MONTHLY_PENCE * (100 - ANNUAL_DISCOUNT_PERCENT)) / 100;

/** £1, £10.80 — whole pounds without pence, part pounds with two places. */
export function pounds(pence) {
  return pence % 100 === 0 ? `£${pence / 100}` : `£${(pence / 100).toFixed(2)}`;
}

export const MONTHLY = pounds(MONTHLY_PENCE);            // "£1"
export const ANNUAL = pounds(ANNUAL_PENCE);              // "£10.80"
export const MONTHLY_PER_USER = MONTHLY_PENCE / 100;     // 1    — for formatCurrency()
export const ANNUAL_PER_USER = ANNUAL_PENCE / 100;       // 10.8 — for formatCurrency()
export const ANNUAL_SAVING = `Save ${ANNUAL_DISCOUNT_PERCENT}%`;
